// The draft's formatting keys, the same on the site and in the desktop app: ⌘ on a Mac where
// Windows and Linux use Ctrl. They're the ones Docs, Jira, Slack, and Notion use, and the shortcut
// settings keep them free (see STANDARD in @lyrmo/shared/shortcuts). Subscript and superscript
// have none, as in Jira.
import type { Block, Format } from './markdown-edit';

export type FormatKey =
  Exclude<Format, 'sub' | 'sup'> | 'link' | 'clear' | Extract<Block, 'bullet' | 'ordered' | 'task'>;

export const FORMAT_KEYS: Readonly<Record<FormatKey, string>> = {
  strong: 'Mod+B',
  em: 'Mod+I',
  underline: 'Mod+U',
  strike: 'Mod+Shift+X',
  code: 'Mod+E',
  link: 'Mod+K',
  clear: 'Mod+\\',
  ordered: 'Mod+Shift+7',
  bullet: 'Mod+Shift+8',
  task: 'Mod+Shift+9',
};
